import { Button, Dropdown, Space, Typography } from 'antd'
import { Header } from 'antd/lib/layout/layout'
import { CaretDownOutlined, MenuOutlined } from '@ant-design/icons';

import Notification from "../../assets/notification.svg"
import Profile from "../../assets/profile.jpg"
import React from 'react'
import { Link, useNavigate } from 'react-router-dom';
import useLocalStorage from '../../utils';
import { useMiddlewareContext } from '../../middleware';

const Navbar = ({ open, close, setOpen }) => {
    const items = [
        {
            label: '1st menu item',
            key: '1',
        },
        {
            label: '2nd menu item',
            key: '2',
        },
        {
            label: '3rd menu item',
            key: '3',
        },
    ];
    const navigate = useNavigate();

    const onSignout = async () => {

        localStorage.removeItem('token')
        localStorage.removeItem('refreshToken')
        navigate('/sign_in')
    }
    return (
        <Header
            className="flex_end_spacebetween"
            style={{
                position: 'relative',
                height: 100, background: "var(--color-white)",
                boxShadow: "var(--main-shadow)",
                zIndex: 2,
                padding: '0 80px',
            }}>
            <div className='menu_icon nav_icon' onClick={setOpen} >

                <MenuOutlined style={{ fontSize: 22 }} />
            </div>
            <Space>
                <div style={{ position: "relative", margin: "0 48px" }}>
                    <div
                        style={{
                            width: 10, height: 10, background: "var(--color-orange)",
                            borderRadius: "50%", position: "absolute", top: 16, right: 0
                        }} >
                    </div>
                    <Dropdown
                        menu={{
                            items,
                        }}
                        trigger={['click']}
                        placement="bottom"
                    >

                        <img style={{ width: 24, height: 30, cursor: 'pointer' }} src={Notification} alt="notification" />
                    </Dropdown>
                </div>
                <Link to='/'>
                    <img src={Profile} style={{ borderRadius: "50%", width: 48, height: 48, }} alt="profile" />
                </Link>
                <Dropdown
                    menu={{ items: [{ label: <Button style={{ color: "var(--color-crimson)" }} type="text" onClick={onSignout}>Sign out</Button>, key: '0' }] }}
                    trigger={['click']}>
                    <a onClick={e => e.preventDefault()}>
                        <Space  >
                            <Typography className='profile_name' style={{ color: "var(--color-black)", fontSize: 16, fontWeight: 500 }} >Jovelle</Typography>
                            <CaretDownOutlined />
                        </Space>
                    </a>
                </Dropdown>

            </Space>
        </Header>
    )
}

export default Navbar